import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from 'redux/store';

import Routes from 'components/Routes/Routes';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter primary={false}>
        <Routes />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
